import { render, staticRenderFns } from "./DetailReceipt.vue?vue&type=template&id=a4a5d638&scoped=true&"
import script from "./DetailReceipt.vue?vue&type=script&lang=ts&"
export * from "./DetailReceipt.vue?vue&type=script&lang=ts&"
import style0 from "./DetailReceipt.vue?vue&type=style&index=0&id=a4a5d638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a5d638",
  null
  
)

export default component.exports